import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import AuthLayout, { authStyles as s } from './components/AuthLayout';
import googleIcon from './assets/images/auth/google.png';
import appleIcon from './assets/images/auth/apple.png';
import facebookIcon from './assets/images/auth/facebook.png';

const ERROR_MSG = {
  email_already_used: '이미 가입된 이메일입니다.',
  password_too_short: '비밀번호는 최소 8자 이상이어야 합니다.',
  missing_fields: '모든 필드를 입력해주세요.',
};

function disabledClick(e) {
  e.preventDefault();
  alert('준비 중입니다');
}

export default function SignUp() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    if (password !== confirm) return setError('비밀번호가 일치하지 않습니다.');
    if (password.length < 8) return setError(ERROR_MSG.password_too_short);
    setSubmitting(true);
    try {
      const res = await fetch('/api/auth/signup', {
        method: 'POST',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email, password, name }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(ERROR_MSG[data.error] || '가입에 실패했습니다.');
        return;
      }
      await refresh();
      navigate('/', { replace: true });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout title="Create your account">
      <form onSubmit={onSubmit}>
        <div className={s.field}>
          <label className={s.label}>Name</label>
          <input className={s.input} type="text" placeholder="Name" autoComplete="name"
            value={name} onChange={e => setName(e.target.value)} required />
        </div>
        <div className={s.field}>
          <label className={s.label}>Email</label>
          <input className={s.input} type="email" placeholder="Email" autoComplete="email"
            value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        <div className={s.field}>
          <label className={s.label}>Password (min 8 chars)</label>
          <input className={s.input} type="password" placeholder="Password" autoComplete="new-password"
            value={password} onChange={e => setPassword(e.target.value)} required minLength={8} />
        </div>
        <div className={s.field}>
          <label className={s.label}>Confirm Password</label>
          <input className={s.input} type="password" placeholder="Confirm Password" autoComplete="new-password"
            value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={8} />
        </div>
        {error && <p className={s.error}>{error}</p>}
        <button className={s.primary} type="submit" disabled={submitting}>
          {submitting ? '가입 중...' : 'Sign Up'}
        </button>
      </form>

      <div className={s.divider}><span>Or continue with</span></div>

      <div className={s.ssoRow}>
        <button
          type="button"
          className={s.ssoButton}
          onClick={() => { window.location.href = '/api/auth/google'; }}
          title="Google로 가입/로그인"
        >
          <img src={googleIcon} alt="Google" />
        </button>
        <button className={s.ssoButton} onClick={disabledClick} disabled title="준비 중">
          <img src={appleIcon} alt="Apple" />
        </button>
        <button className={s.ssoButton} onClick={disabledClick} disabled title="준비 중">
          <img src={facebookIcon} alt="Facebook" />
        </button>
      </div>

      <div className={s.linkRow}>
        Already have an account?<Link to="/login">Sign In</Link>
      </div>
    </AuthLayout>
  );
}
